import React from 'react';
import { CheckoutConfig } from '../../../types';

export const TrustAndSecurityBadge: React.FC<{ config: CheckoutConfig }> = ({ config }) => {
  if (!config.showSecurityBadge && !config.showTrustBar && !config.showGuarantee) return null;

  return (
    <div className="space-y-3 pt-3 border-t border-slate-200/70 dark:border-slate-800 text-center">
      {config.showGuarantee && (
        <div className="flex items-center justify-center gap-2 p-2 bg-amber-50/80 dark:bg-amber-950/30 border border-amber-200/80 dark:border-amber-800/50 rounded-lg text-amber-800 dark:text-amber-300 text-xs font-bold">
          <svg className="w-4 h-4 text-amber-600 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <span>{config.guaranteeText || '30-Day 100% Money-Back Guarantee'}</span>
        </div>
      )}

      {config.showSecurityBadge && (
        <div className="flex items-center justify-center gap-1.5 text-slate-500 dark:text-slate-400 text-[11px] font-semibold">
          <svg className="w-3.5 h-3.5 text-emerald-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <span>PCI-DSS Compliant & 256-Bit SSL Encrypted</span>
        </div>
      )}

      {config.showTrustBar && config.trustLogos && config.trustLogos.length > 0 && (
        <div className="pt-2">
          <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold mb-2">
            Trusted by modern leaders
          </p>
          <div className="flex items-center justify-center gap-4 opacity-50 grayscale hover:grayscale-0 transition-all">
            {config.trustLogos.map((logo, idx) => (
              <img key={idx} src={logo} alt="Trust logo" className="h-4 max-w-[70px] object-contain" />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export const SocialProofAndFomo: React.FC<{ config: CheckoutConfig }> = ({ config }) => {
  return (
    <>
      {config.showFomo && config.fomoMessage && (
        <div className="flex items-center gap-2 p-2.5 bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-800 rounded-lg text-rose-800 dark:text-rose-300 text-xs font-semibold animate-pulse">
          <span className="w-2 h-2 rounded-full bg-rose-500 animate-ping"></span>
          <span>{config.fomoMessage}</span>
        </div>
      )}
      {config.showSocialProof && config.socialProofText && (
        <div className="flex items-center justify-center gap-2 text-xs font-bold text-indigo-600 dark:text-indigo-400 py-1">
          <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          <span>{config.socialProofText}</span>
        </div>
      )}
    </>
  );
};
